<h2><ng-content></ng-content></h2>

@if (subTitle) {
  <h3 class="report-header-subtitle">{{ subTitle }}</h3>
}
